import Component from '@bythepixel/component-loader';
import { selectors } from './config';

export default class SectionSubModels extends Component {
  static selector = '[data-comp-section-sub-models]';

  revealer;

  constructor(containerEl) {
    super(containerEl);
    this.revealer = containerEl.querySelector(selectors.revealer);

    this.mount();
  }

  attachListeners() {
    this.revealer?.addEventListener('click', () => {
      this.expand();
    });
  }

  isExpanded() {
    return this.$container.ariaExpanded === 'true';
  }

  expand() {
    this.$container.ariaExpanded = 'true';
  }

  mount() {
    this.attachListeners();
  }
}
